export const AUDIO_READY_STATES = {
  HAVE_NOTHING: 0,
  HAVE_METADATA: 1,
  HAVE_CURRENT_DATA: 2,
  HAVE_FUTURE_DATA: 3,
  HAVE_ENOUGH_DATA: 4,
}

export const MEDIA_ERRORS = [
  { code: 1, message: 'Audio playback was aborted by the user.' },
  { code: 2, message: 'Network error occurred while loading the audio.' },
  { code: 3, message: 'Audio is not available [Corrupted].' },
  { code: 4, message: 'The audio source format is not supported.' },
]

export const SSL_CERT_ERROR_MESSAGE = 'The audio link has an invalid or expired SSL certificate.'

export const AUDIO_LOADING_STATE = 'loading_audio'
